

<div class="row">
	<div class="col-12">
		<div class="kt-form"[formGroup]="promotionForm">
			<mat-tab-group>
				<mat-tab label="Main">
					<div class="row">
						<div class="col-12">
							<div class="form-group">
								<label>Promotion name</label>
								<input type="text" class="form-control" formControlName="promoName"/>
							</div>
							<div class="form-group">
								<label >Master promotion text</label>
								<textarea class="form-control" rows="2" formControlName="masterPromoText"></textarea>
								<span *ngIf="f.masterPromoText.invalid && (f.masterPromoText.dirty || f.masterPromoText.touched)" class="form-text text-danger">Information!</span>
							</div>
							<div class="form-group">
								<mat-checkbox formControlName="categoryOverridesMasterPromoText">Category promotion text overrides Master promotion text!</mat-checkbox>
							</div>
						</div>
					</div>
				</mat-tab>
				<mat-tab label="Hosting">
					<div class="row">
						<div class="col-12">
							<div class="form-group">
								<label>Hosting Coupon code</label>
								<input type="text" class="form-control" formControlName="hostingCoupon"/>
								<span *ngIf="f.hostingCoupon.invalid && (f.hostingCoupon.dirty || f.hostingCoupon.touched)" class="form-text text-danger">Up to {{defaultCouponMaxLength}} characters!</span>
							</div>
							<div class="form-group mb-3">
								<label>Hosting Promotion text</label>
								<textarea class="form-control" rows="2" formControlName="hostingPromoText"></textarea>
							</div>
						</div>
					</div>
				</mat-tab>
				<mat-tab label="Streaming">
					<div class="row">
						<div class="col-12">
							<div class="form-group">
								<label>Streaming Coupon code</label>
								<input type="text" class="form-control" formControlName="streamingCoupon"/>
								<span *ngIf="f.streamingCoupon.invalid && (f.streamingCoupon.dirty || f.streamingCoupon.touched)" class="form-text text-danger">Up to {{defaultCouponMaxLength}} characters!</span>
							</div>
							<div class="form-group mb-3">
								<label>Streaming Promotion text</label>
								<textarea class="form-control" rows="2" formControlName="streamingPromoText"></textarea>
							</div>
						</div>
					</div>
				</mat-tab>
				<mat-tab label="Applications">
					<div class="row">
						<div class="col-12">
							<div class="form-group">
								<label>Applications Coupon code</label>
								<input type="text" class="form-control" formControlName="applicationsCoupon"/>
								<span *ngIf="f.applicationsCoupon.invalid && (f.applicationsCoupon.dirty || f.applicationsCoupon.touched)" class="form-text text-danger">Up to {{defaultCouponMaxLength}} characters!</span>
							</div>
							<div class="form-group mb-3">
								<label>Applications Promotion text</label>
								<textarea class="form-control" rows="2" formControlName="applicationsPromoText"></textarea>
							</div>
						</div>
					</div>
				</mat-tab>
				<mat-tab label="Hosting (Reseller)">
					<div class="row">
						<div class="col-12">
							<div class="form-group">
								<label>Hosting (Reseller) Coupon code</label>
								<input type="text" class="form-control" formControlName="resellerHostingCoupon"/>
								<span *ngIf="f.resellerHostingCoupon.invalid && (f.resellerHostingCoupon.dirty || f.resellerHostingCoupon.touched)" class="form-text text-danger">Up to {{defaultCouponMaxLength}} characters!</span>
							</div>
							<div class="form-group mb-3">
								<label>Hosting (Reseller) Promotion text</label>
								<textarea class="form-control" rows="2" formControlName="resellerHostingPromoText"></textarea>
							</div>
						</div>
					</div>
				</mat-tab>
				<mat-tab label="Streaming (Reseller)">
					<div class="row">
						<div class="col-12">
							<div class="form-group">
								<label>Streaming (Reseller) Coupon code</label>
								<input type="text" class="form-control" formControlName="resellerStreamingCoupon"/>
								<span *ngIf="f.resellerStreamingCoupon.invalid && (f.resellerStreamingCoupon.dirty || f.resellerStreamingCoupon.touched)" class="form-text text-danger">Up to {{defaultCouponMaxLength}} characters!</span>
							</div>
							<div class="form-group mb-3">
								<label>Streaming (Reseller) Promotion text</label>
								<textarea class="form-control" rows="2" formControlName="resellerStreamingPromoText"></textarea>
							</div>
						</div>
					</div>
				</mat-tab>
			</mat-tab-group>
		</div>
	</div>

</div>
<div class="row mb-2 no-gutters mt-3">
  <div class="col-12">
    <button mat-button class="float-left ml-2" (click)="onNoClick()">Cancel</button>&nbsp;
    <button mat-button class="float-right mr-2" (click)="onYesClick()" [disabled]="f.promoName.value.length === 0" color="primary">UPDATE</button>
  </div>
</div>
